// Заказы, которые появились в списке при пересинхронизации, а звука по ним не было:
// пока сокет лежал, событие о них прошло мимо.
// Без импортов и в CommonJS, чтобы тест запускался голым node, как у refresh-registry.

function findMissedOrders (shownOrders, freshOrders, announcedIds) {
  const shownIds = new Set(shownOrders.map((order) => order.id))

  return freshOrders.filter((order) => !shownIds.has(order.id) && !announcedIds.has(order.id))
}

module.exports = {
  findMissedOrders,
}
